export default {
    StockVerifyConfigutration: {
        strategy: '库存审核策略',
        audit: '逻辑仓调拨审核',
        virtual: '虚仓移仓审核',
        approval: '库存预留审核',
        review: '分仓计划审核',
        confirmMsg: '当前页面数据未保存，是否直接重置？',
        cancelled: '已取消'
    }
};
